import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateLaborTaskAssignmentMutationVariables = Types.Exact<{
  input: Types.CreateTaskAssignmentInput;
}>;


export type CreateLaborTaskAssignmentMutation = { __typename?: 'Mutation', createTaskAssignment: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, tenantId: string, assignedTo?: string | null, productionJobId?: string | null, taskEventName: string, sourceLevel: Types.TaskAssignmentSourceLevel, status: Types.TaskAssignmentStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', message: string, code?: string | null }> | null } };

export type CancelLaborTaskMutationVariables = Types.Exact<{
  input: Types.CancelTaskInput;
}>;


export type CancelLaborTaskMutation = { __typename?: 'Mutation', cancelTask: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, status: Types.TaskAssignmentStatus, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateLaborTaskAssignmentDocument = new TypedDocumentString(`
    mutation CreateLaborTaskAssignment($input: CreateTaskAssignmentInput!) {
  createTaskAssignment(input: $input) {
    taskAssignment {
      taskAssignmentId
      tenantId
      assignedTo
      productionJobId
      taskEventName
      sourceLevel
      status
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
    errors {
      message
      code
    }
  }
}
    `);
export const CancelLaborTaskDocument = new TypedDocumentString(`
    mutation CancelLaborTask($input: CancelTaskInput!) {
  cancelTask(input: $input) {
    taskAssignment {
      taskAssignmentId
      status
      updatedAt
      updatedBy
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateLaborTaskAssignment: build.mutation<CreateLaborTaskAssignmentMutation, CreateLaborTaskAssignmentMutationVariables>({
      query: (variables) => ({ document: CreateLaborTaskAssignmentDocument, variables })
    }),
    CancelLaborTask: build.mutation<CancelLaborTaskMutation, CancelLaborTaskMutationVariables>({
      query: (variables) => ({ document: CancelLaborTaskDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateLaborTaskAssignmentMutation, useCancelLaborTaskMutation } = injectedRtkApi;
